import {ChangeDetectionStrategy, Component, Input, NgModule, OnInit, ViewChild} from '@angular/core';
import {
	NgbCalendar,
	NgbDateAdapter,
	NgbDateParserFormatter,
	NgbDatepicker, NgbDatepickerModule,
	NgbDateStruct, NgbDropdownModule,
	NgbPeriod, NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {NgbDateCustomAdapter, NgbDateCustomParserFormatter} from 'shared/_services/ngb-date-adapter.service';
import {ICalendarOverlay} from '../../../../journal/src/_interface/ICalendarOverlay';
import { set } from 'lodash-es';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';

@Component({
	selector: 'shared-calendar-with-overlay',
	templateUrl: './calendar-with-overlay.component.html',
	styleUrls: ['./calendar-with-overlay.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{provide: NgbDateAdapter, useClass: NgbDateCustomAdapter},
		{provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
	]
})
export class CalendarWithOverlayComponent implements OnInit {
	@ViewChild('dp') dp: NgbDatepicker;
	@Input() hideName = true;
	@Input() control: UntypedFormControl;
	@Input() set overlay(o: ICalendarOverlay[]) {
		o.forEach(item => set(this.calOverlay, `year_${item.dateObj.year}.month_${item.dateObj.month}.day_${item.dateObj.day}`, item));
	}

	@Input() set min(m: string) {
		if (m) this.minDate = this.pf.parse(m);
	}

	@Input() set max(m: string) {
		if (m) this.maxDate = this.pf.parse(m);
	}

	calOverlay: { [year: string]: { [month: string]: { [day: string]: ICalendarOverlay } } } = {};

	startDate: NgbDateStruct;
	minDate: NgbDateStruct;
	maxDate: NgbDateStruct;
	months = Array.from({length: 12}).map((_, i) => new Date(2020, i));
	years = Array.from({length: 23}).map((_, i) => 2000 + i);

	constructor(private cal: NgbCalendar, private pf: NgbDateCustomParserFormatter) { }

	ngOnInit(): void {
		if (this.control.value) this.startDate = this.pf.parse(this.control.value);
	}

	monthChange = ($event: Event) => this.dp.navigateTo({
		year: this.dp.model.focusDate.year,
		month: Number(($event.target as HTMLSelectElement).value) + 1
	})

	yearChange = ($event: Event) => this.dp.navigateTo({
		month: this.dp.model.focusDate.month,
		year: Number(($event.target as HTMLSelectElement).value)
	})

	next(forward = true, period: NgbPeriod = 'm') {
		const method = forward ? 'getNext' : 'getPrev';
		const next = this.cal[method](this.dp.model.focusDate, period, 1);
		this.dp.navigateTo(next);
	}
}

@NgModule({
	declarations: [CalendarWithOverlayComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		NgbDatepickerModule,
		NgbDropdownModule,
		NgbTooltipModule,
		TranslocoModule
	],
	exports: [CalendarWithOverlayComponent]
})
export class CalendarWithOverlayModule {}
